<nav mat-tab-nav-bar
  [class]="inputClass"
  [disablePagination]="true"
  [tabPanel]="tabPanel">

  <swiper #swiper class="navigation-carousel" [config]="carouselConfig">
    @for (link of links; track link; let i = $index) {
      <ng-template swiperSlide>
        @if (!link.roles || currentUser.hasRoles(link.roles)) {
          <a (click)="slideToActiveTab(i)"
            tourAnchor="tab{{ link.label }}"
            mat-tab-link
            routerLinkActive
            #rla="routerLinkActive"
            (isActiveChange)="slideToActiveTab(i)"
            [attr.id]="link.id"
            [active]="rla.isActive"
            [routerLink]="[link.url]">
            {{link.label}}
          </a>
        }
      </ng-template>
    }
  </swiper>
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
